<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <h1>Subscriptions Details</h1>
      <div class="alert alert-danger mt-3" *ngIf="errorMessage">{{ errorMessage }}</div>
    </div>
  </div>
  <div class="row accordion-item" *ngFor="let subscription of user?.subscriptions; let i = index">
    <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="!loading">
      <div class="subscription-name">
        <div class="subscription-summary">
          <ng-container *ngIf="subscription.subscriptionId; else paymentLinkInfo">
            <h2>{{subscription.subscriptionName}} {{subscription.startDate}} - {{subscription.endDate}} ({{subscription.lessonsCountInitial}} lessons, {{subscription.lessonsCountLeft}} left) - &euro; {{subscription.price}} -{{subscription.isPaid ? 'Paid' : 'Unpaid'}}</h2>
            <button type="button" class="btn btn-default toggle-subscription-button" (click)="toggleItem(i)" *ngIf="subscription.isPaid">
              <i [class]="'fas' + (activeIndex === i ? ' fa-chevron-up' : ' fa-chevron-down')"></i>
            </button>
          </ng-container>
          <ng-template #paymentLinkInfo>
            <h2>Payment link - {{ subscription.createdDate | date:'yyyy-MM-dd' }} - &euro; {{subscription.price}} - {{subscription.isPaid ? 'Paid' : 'Unpaid'}}</h2>
          </ng-template>
        </div>
        <button
          type="button"
          class="btn btn-danger remove-subscription-button"
          [disabled]="removingSubscriptionId === subscription.id"
          (click)="removeSubscription(subscription.id, subscription.subscriptionName || 'Payment link')">
          {{ removingSubscriptionId === subscription.id ? 'Removing...' : 'Remove' }}
        </button>
      </div>
      <div class="table-responsive" [@accordionAnimation]="activeIndex === i ? 'open' : 'closed'">
        <table class="table table-responsive-lg schedule-table" *ngIf="subscription.lessonsCountInitial >= subscription.lessonsCountLeft; else thereAreNoBookedLessons">
          <thead>
          <tr>
            <th scope="col" class="text-center">Lesson</th>
            <th scope="col" class="text-center">Date</th>
            <th scope="col" class="text-center">Time</th>
            <th scope="col" class="text-center">Child Name</th>
            <th scope="col" class="text-center">Teacher Name</th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let bookedLesson of userBookedLessons[subscription.id]">
              <td class="text-center">
                {{bookedLesson.name}}
              </td>
              <td class="text-center">
                {{bookedLesson.bookingDate}}
              </td>
              <td class="text-center">
                {{bookedLesson.startTime}} - {{bookedLesson.endTime}}
              </td>
              <td class="text-center">
                {{bookedLesson.childFirstName}} {{bookedLesson.childLastName}}
              </td>
              <td class="text-center">
                {{bookedLesson.teacherFirstName}} {{bookedLesson.teacherLastNameName}}
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #thereAreNoBookedLessons>
          <h5 class="no-booked-lessons">There a no booked lessons in subscription</h5>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!loading && !user?.subscriptions?.length">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <h5 class="no-booked-lessons">There are no subscriptions for this user</h5>
    </div>
  </div>
</div>
